export const environment = {
  ns: 'DEVELOPMENT',
  production: false,
  cookieKey: 'kaz-frontend-development',
  cookieBaseUrl: 'kleinanzeigen.blackforestbytes.de',
  apiBaseUrl: '/api/v1/',
};
